{
  "title": "Bayad at buwis",
  "lead": "Tantiyahin ang iyong lokal na buwis, i-save ang tantiya, at magbayad sa Treasurer's Office.",
  "noOnlinePay": "Wala pang online na pagbabayad. Magbayad sa counter ng Treasurer at itago ang iyong opisyal na resibo.",
  "tab_cedula": "Cedula",
  "tab_rpt": "Amilyar",
  "tab_business": "Buwis sa negosyo",
  "tab_mine": "Aking mga tantiya",
  "estimateTitle": "Ang iyong tantiya",
  "estimateNote": "Tantiya lamang ito. Ang Treasurer's Office ang magkukuwenta ng opisyal na halaga kapag nagbayad ka.",
  "enterValues": "Ilagay ang iyong mga halaga para makita ang tantiya.",
  "total": "Kabuuan",
  "invalidAmount": "Maglagay ng halaga sa piso, halimbawa 180000",
  "amountHint": "Halaga noong nakaraang taon. Iwanang blangko kung wala.",
  "cedulaTitle": "Community tax certificate (cedula)",
  "cedulaWho": "Sino ang magbabayad",
  "cedulaIndividual": "Indibidwal",
  "cedulaJuridical": "Korporasyon o partnership",
  "cedulaLead": "Ilagay ang kita noong nakaraang taon. Iwanang blangko ang hindi para sa iyo.",
  "cedulaJuridicalLead": "Ilagay ang mga numero ng negosyo noong nakaraang taon.",
  "salaries": "Sahod o suweldo (₱)",
  "businessIncome": "Kabuuang kita mula sa negosyo o propesyon (₱)",
  "propertyIncome": "Kita mula sa ari-ariang lupa o gusali (₱)",
  "propertyAssessedValue": "Assessed value ng pag-aaring lupa o gusali (₱)",
  "grossReceipts": "Kabuuang kita mula sa negosyo (₱)",
  "cedulaLaw": "Local Government Code Sek. 157: ₱5.00 na basic tax, dagdag na ₱1.00 sa bawat ₱1,000 na kita, hanggang ₱5,000 pa.",
  "cedulaJuridicalLaw": "Local Government Code Sek. 158: ₱500 na basic tax, dagdag na ₱2.00 sa bawat ₱5,000 ng halaga ng ari-arian at ng kabuuang kita, hanggang ₱10,000 pa.",
  "cedulaDue": "Magbayad bago matapos ang Pebrero. Ang huling pagbabayad ay may interes na 24% bawat taon (LGC Sek. 161).",
  "cedulaBring": "Magdala ng valid ID at patunay ng kita, gaya ng income tax return o certificate of compensation.",
  "rptTitle": "Amilyar (real property tax)",
  "rptLead": "Gamitin ang mga halagang nakasulat sa iyong tax declaration.",
  "marketValue": "Market value (₱)",
  "propertyClass": "Uri ng ari-arian",
  "chooseClass": "Piliin ang uri ng ari-arian",
  "classOption": "{label} ({percent}%)",
  "otherClass": "Iba pa — ilalagay ko ang level",
  "assessmentLevel": "Assessment level (%)",
  "assessmentLevelHint": "Nakasulat sa iyong tax declaration, halimbawa 20.",
  "levelInvalid": "Maglagay ng porsiyento mula 1 hanggang 100",
  "tdNumber": "Numero ng tax declaration",
  "payInAdvance": "Babayaran ko nang buo ang buong taon nang maaga ({discount}% diskuwento)",
  "assessedValue": "Assessed value",
  "perQuarter": "Bawat quarter (walang diskuwento)",
  "ratesCeiling": "Ginagamit ang pinakamataas na rate ayon sa batas: {basic}% basic tax at {sef}% Special Education Fund (LGC Sek. 233 at 235). Maaaring mas mababa ang rate sa ordinansa ng LGU.",
  "ratesLgu": "Mga rate na inilathala ng Treasurer's Office: {basic}% basic tax at {sef}% Special Education Fund.",
  "rptDue": "Magbayad taun-taon, o sa apat na hulog bago ang Marso 31, Hunyo 30, Setyembre 30 at Disyembre 31 (LGC Sek. 250).",
  "rptDiscountLaw": "Maaaring magbigay ang LGU ng hanggang 20% diskuwento sa maaga o napapanahong pagbabayad (LGC Sek. 251).",
  "lguNotes": "Paalala mula sa Treasurer's Office",
  "businessTitle": "Buwis sa negosyo at bayad sa permit",
  "businessLead": "Kinukuwenta ng Business Permits and Licensing Office (BPLO) at ng Treasurer ang buwis sa negosyo batay sa kabuuang benta noong nakaraang taon, gamit ang mga rate sa municipal revenue code, kasama ang mga regulatory fee.",
  "businessWindow": "Panahon ng renewal",
  "businessWindowBody": "Karaniwang Enero 1 hanggang 20 bawat taon (LGC Sek. 165), maliban kung palawigin ng LGU.",
  "businessPrepare": "Ano ang ihahanda",
  "businessPrepareBody": "Permit noong nakaraang taon, idineklarang kabuuang benta, barangay clearance, at iba pang clearance na hinihingi ng BPLO.",
  "businessPay": "Pagtatasa at pagbabayad",
  "businessPayBody": "Ang BPLO at ang Treasurer ang nagkukuwenta ng iyong buwis at bayarin; magbabayad ka sa Treasurer's Office.",
  "businessServices": "Tingnan ang mga serbisyo ng BPLO",
  "save": "I-save ang tantiyang ito",
  "saving": "Sine-save…",
  "saved": "Na-save bilang {ref}. Ipakita ito sa counter ng Treasurer.",
  "signInToSave": "Mag-sign in para i-save ang tantiya",
  "signInToSee": "Mag-sign in para makita ang mga na-save mong tantiya.",
  "mineTitle": "Aking mga tantiya",
  "mineEmpty": "Wala ka pang na-save na tantiya",
  "mineEmptyBody": "Gamitin ang estimator ng cedula o amilyar at i-save ito para bayaran sa counter.",
  "showAtCounter": "Ipakita ang reference o QR code na ito sa counter ng Treasurer.",
  "reference": "Reference",
  "qrAlt": "QR code para sa {ref}",
  "showBreakdown": "Tingnan kung paano kinuwenta",
  "status_unpaid": "Babayaran sa counter",
  "status_paid": "Bayad na",
  "status_cancelled": "Kinansela",
  "paidWith": "Binayaran {date} · OR {or}",
  "savedOn": "Na-save {date}",
  "taxYear": "Taon ng buwis {year}",
  "cancel": "Kanselahin ang tantiyang ito",
  "cancelTitle": "Kanselahin ang tantiyang ito?",
  "cancelBody": "Puwede kang gumawa ulit ng bago anumang oras.",
  "cancelYes": "Oo, kanselahin",
  "keep": "Huwag na",
  "cancelled": "Nakansela ang tantiya.",
  "cancelledOn": "Kinansela {date}",
  "type_cedula_individual": "Cedula (indibidwal)",
  "type_cedula_juridical": "Cedula (korporasyon)",
  "type_rpt": "Amilyar",
  "line_basicCedula": "Basic na cedula",
  "line_additionalCedula": "Karagdagang cedula",
  "line_basicRpt": "Basic na amilyar",
  "line_sef": "Special Education Fund",
  "line_discount": "Diskuwento sa maagang pagbabayad",
  "deskTitle": "Revenue desk",
  "deskLead": "Mga tantiyang na-save ng mga residente para bayaran dito. Hanapin ayon sa reference, pangalan o mobile number, saka itala ang opisyal na resibo.",
  "tab_desk": "Mga tantiya",
  "tab_rates": "Mga rate ng buwis",
  "search": "Reference, pangalan o mobile number",
  "filterStatus": "Katayuan",
  "filterAll": "Lahat",
  "filterYear": "Taon ng buwis",
  "allYears": "Lahat ng taon",
  "scan": "I-scan ang QR",
  "scanTitle": "I-scan ang QR code ng residente",
  "scanHint": "O i-type ang reference sa search box.",
  "cameraView": "Tanaw ng camera",
  "startCamera": "Buksan ang camera",
  "stopCamera": "Isara ang camera",
  "cameraDenied": "Naka-block ang camera. Payagan ito sa settings ng browser, o i-type ang reference.",
  "cameraError": "Hindi mabuksan ang camera. I-type na lang ang reference.",
  "notAnEstimate": "Hindi reference ng tantiya ang QR code na iyon.",
  "totalsUnpaid": "Kokolektahin",
  "totalsPaid": "Nakolekta",
  "countOne": "1 tantiya",
  "countOf": "{count} tantiya",
  "exportCsv": "I-download ang CSV",
  "deskEmpty": "Walang nakitang tantiya",
  "deskEmptyBody": "Nagse-save ang mga residente ng tantiya mula sa Bayad at buwis sa app.",
  "deskEmptySearch": "Suriin ang reference o subukan ang mobile number ng residente.",
  "deletedAccount": "Binurang account",
  "readOnly": "Puwede kang maghanap ng tantiya. Kailangan ng editor role para magtala ng bayad.",
  "recordPayment": "Itala ang bayad",
  "deskCancel": "Kanselahin",
  "payTitle": "Bayad para sa {ref}",
  "payLead": "Pagkatapos magbayad si {name} ng {amount}, ilagay ang numero ng opisyal na resibo.",
  "orNumber": "Numero ng opisyal na resibo (OR)",
  "orHint": "Gaya ng nakalimbag sa resibo. Isang beses lang maitatala ang bawat OR.",
  "payConfirm": "Itala ang bayad",
  "paidToast": "Naitala ang bayad. Naabisuhan na ang residente.",
  "orLine": "OR {or} · {date}",
  "recordedBy": "ni {name}",
  "deskCancelTitle": "Kanselahin ang {ref}?",
  "deskCancelBody": "Gawin lang ito kung hiniling ng residente, o kung nagkamali sa pag-save.",
  "ratesTitle": "Mga rate para sa estimator",
  "ratesLead": "Ginagamit ang mga rate na ito sa tantiya ng amilyar ng mga residente. Iwanang blangko para gamitin ang pinakamataas na rate ayon sa batas, na ipinapakita bilang ganoon.",
  "ratesReadOnly": "Ang mga editor lang ang puwedeng magbago ng mga rate.",
  "lastUpdated": "Huling binago {date}",
  "basicRate": "Basic na amilyar (%)",
  "basicRateHint": "Pinakamataas ayon sa batas: 1% sa lalawigan, 2% sa lungsod at mga munisipyo sa Metro Manila.",
  "sefRate": "Special Education Fund (%)",
  "sefRateHint": "Pinakamataas ayon sa batas: 1%.",
  "advanceDiscount": "Diskuwento sa maagang pagbabayad ng buong taon (%)",
  "promptDiscount": "Diskuwento sa napapanahong pagbabayad (%)",
  "discountHint": "Hanggang 20% (LGC Sek. 251). Iwanang blangko kung wala.",
  "rateInvalid": "Maglagay ng numero mula 0 hanggang {max}",
  "levelsTitle": "Assessment level ayon sa uri ng ari-arian",
  "levelsHint": "Mula sa ordinansa ng lalawigan o lungsod, halimbawa Residential 20%. Mapipili ito ng mga residente sa estimator.",
  "levelLabel": "Uri ng ari-arian",
  "levelPercent": "Level (%)",
  "levelLabelRequired": "Pangalanan ang uri ng ari-arian",
  "addLevel": "Magdagdag ng uri ng ari-arian",
  "removeLevel": "Alisin ang {label}",
  "notes": "Paalala para sa mga residente",
  "notesHint": "Ipinapakita kasama ng estimator ng amilyar, hal. numero ng ordinansa o oras ng opisina.",
  "saveRates": "I-save ang mga rate",
  "ratesSaved": "Na-save ang mga rate."
}
